import baseService from '@/utils/http/axios'
import { message } from 'ant-design-vue'

/**
 * * usb电话机
 * http://www.hion.cn/article/15.html
 * u880
 */
const usbphone = {
    state: {
        wsClient: null,//websocket客户端
        wsip: 'ws://127.0.0.1:823',//websocket服务器地址
        inp_recordaddr: "",//录音文件存放地址"D:\\usbphonerecord\\sound.wav"
        tip: [],//提示信息
        spush: [],//

        p_status: 0,//摘挂机状态0:为挂机;1：为摘机;2:为HOLD;3：为耳机摘机
        r_status: 0,//录音机状态： 0：停止录音 1:正在录音
        a_status: 0,//答录的状态： 0：停止答录 1：准备答录 2:正在答录（留言）
        dv_status: 0,//播号音开关: 0: 播号音关闭 1：播号音打开
        icm_flag: 0,//ICM通道关：0；ICM通道开： 1
        has_dial: false,//标识是否已发送预拨号命令
        pre_p_status: 0,//记录上一次摘挂机状态

        ringCount: 0,//来电次数
        incomTimeout: null,//来电超时定时器
        autoRecordID: null,//自动录音ID定时器
        dlyDlokTimeout: null,//延时摘机定时器
        phoneCode: null,
        phoneCodeShow: null,

        serialno: null,//设备序列号
        cnnstate: null,//连接状态
        messagenum: null,//接收到知信内容：
        inp_phonecode: null,//来电号码-一个输入框
        inp_serial: null,//本机序列号-设备串号：

        SetLeaveRecordFlag: 0,
        holdTo503: false,
        isDialOnline: false,//是否为在线播号
        PreDialing: false,//是否正在预拨号

        phone_icm: '',//来电号码
        audioend: 0,//录音结束标志
        rd_icm: false,//ICM通道开关
        pre_command: '',//预拨号命令

        modalVisible: false,//是否显示弹窗
        modalCurentInfo: {
            customer_id: null,
            full_name: '',
            phone: '',
            zipid: null,
            reason: '',
            remark: '',
        },//当前弹窗拨号信息


    },
    mutations: {
        SET_TIP: (state, tip) => {
            state.tip = tip
        },
        SET_WSCLIENT: (state, wsClient) => {
            state.wsClient = wsClient
        },
        SET_INP_RECORDADDR: (state, inp_recordaddr) => {
            state.inp_recordaddr = inp_recordaddr
        },
        SET_WSIP: (state, wsip) => {
            state.wsip = wsip
        },
        SET_P_STATUS: (state, p_status) => {
            state.p_status = p_status
        },
        SET_R_STATUS: (state, r_status) => {
            state.r_status = r_status
        },
        SET_A_STATUS: (state, a_status) => {
            state.a_status = a_status
        },
        SET_DV_STATUS: (state, dv_status) => {
            state.dv_status = dv_status
        },
        SET_ICM_FLAG: (state, icm_flag) => {
            state.icm_flag = icm_flag
        },
        SET_HAS_DIAL: (state, has_dial) => {
            state.has_dial = has_dial
        },
        SET_PRE_P_STATUS: (state, pre_p_status) => {
            state.pre_p_status = pre_p_status
        },
        SET_RINGCOUNT: (state, ringCount) => {
            state.ringCount = ringCount
        },
        SET_INCOM_TIMEOUT: (state, incomTimeout) => {
            state.incomTimeout = incomTimeout
        },
        SET_AUTORECORDID: (state, autoRecordID) => {
            state.autoRecordID = autoRecordID
        },
        SET_INP_SERIAL: (state, inp_serial) => {
            state.inp_serial = inp_serial
        },
        SET_CNNSTATE: (state, cnnstate) => {
            state.cnnstate = cnnstate
        },
        SET_MESSAGENUM: (state, messagenum) => {
            state.messagenum = messagenum
        },
        SET_PHONECODE: (state, phoneCode) => {
            state.phoneCode = phoneCode
        },
        SET_PHONECODESHOW: (state, phoneCodeShow) => {
            state.phoneCodeShow = phoneCodeShow
        },
        SET_INP_PHONECODE: (state, inp_phonecode) => {
            state.inp_phonecode = inp_phonecode
        },
        SET_SERIALNO: (state, serialno) => {
            state.serialno = serialno
        },
        SET_SPUSH: (state, spush) => {
            state.spush = spush
        },
        SET_SETLEAVERECORDFLAG: (state, SetLeaveRecordFlag) => {
            state.SetLeaveRecordFlag = SetLeaveRecordFlag
        },
        SET_HOLDTO503: (state, holdTo503) => {
            state.holdTo503 = holdTo503
        },
        SET_ISDIALONLINE: (state, isDialOnline) => {
            state.isDialOnline = isDialOnline
        },
        SET_PREDIALING: (state, PreDialing) => {
            state.PreDialing = PreDialing
        },
        SET_PHONE_ICM: (state, phone_icm) => {
            state.phone_icm = phone_icm
        },
        SET_AUDIOEND: (state, audioend) => {
            state.audioend = audioend
        },
        SET_RD_ICM: (state, rd_icm) => {
            state.rd_icm = rd_icm
        },
        SET_DLYDLOKTIMEOUT: (state, dlyDlokTimeout) => {
            state.dlyDlokTimeout = dlyDlokTimeout
        },
        SET_PRE_COMMAND: (state, pre_command) => {
            state.pre_command = pre_command
        },
        SET_MODALVISIBLE: (state, modalVisible) => {
            state.modalVisible = modalVisible
        },
        SET_MODALCURENTINFO: (state, modalCurentInfo) => {
            state.modalCurentInfo = modalCurentInfo
        }

    },
    actions: {
        //页面调用打电话弹窗
        AddPhoneModal({ commit, state, dispatch }, { phone, customer_id, full_name }) {
            if (state.p_status != 0) {
                if (phone == state.modalCurentInfo.phone) {
                    dispatch('ShowPhoneModal')
                } else {
                    //不为挂机状态则不能再次拨打电话
                    message.error('当前电话正在通话中，请先挂断电话再拨打电话')
                }
                return
            }
            commit('SET_MODALCURENTINFO', {
                customer_id: customer_id,
                full_name: full_name,
                phone: phone,
                zipid: null,
                reason: '',
                remark: '',
            })
            commit('SET_MODALVISIBLE', true)
        },
        ShowPhoneModal({ commit }) {
            commit('SET_MODALVISIBLE', true)
        },
        HidePhoneModal({ commit }) {
            commit('SET_MODALVISIBLE', false)
        },
        PhoneCall({ commit, state, dispatch }, { phone, zipid }) {
            let now = new Date();
            let year = now.getFullYear();
            let month = String(now.getMonth() + 1).padStart(2, '0');
            let day = String(now.getDate()).padStart(2, '0');
            let hours = String(now.getHours()).padStart(2, '0');
            let minutes = String(now.getMinutes()).padStart(2, '0');
            let seconds = String(now.getSeconds()).padStart(2, '0');

            let folder = `${year}${month}`; // 格式：202607

            // 生成年月日时分秒：20260709143025
            let dateTimeStr = year + month + day + hours + minutes + seconds;

            // 清洗手机号，只保留数字
            let cleanPhone = String(phone).replace(/\D/g, '');
            let cleanZipid = String(zipid).replace(/\D/g, '');

            // 文件名格式：手机号码_zipid_年月日时分秒.wav
            let fileName = `${cleanPhone}_${cleanZipid}_${dateTimeStr}.wav`;
            let wavpath = `D:\\usbphonerecord\\${folder}\\${fileName}`;

            commit('SET_INP_RECORDADDR', wavpath);
            console.log('录音文件路径:', wavpath);

            // 摘机
            dispatch('sentNCommand', { "cmd": "HP_OffHookCtrl", "rid": 3, "para": null });
            // 拨号，摘机后等待2秒再拨号
            setTimeout(() => {
                dispatch('sentNCommand', { "cmd": "HP_StartDial", "rid": 5, "para": phone });
                commit('SET_PREDIALING', true);
            }, 2000);
        },
        PhoneCallEnd({ commit, state, dispatch }) {
            //主动挂断电话
            dispatch('answer_end')
        },
        SendMsg({ commit, state, dispatch }, { phone, msg }) {
            console.log('发送短信', phone, msg)
            //（4G电话机特有指令）发送短消息内容Para，Num为目标手机号
            dispatch('sentCommand', { "cmd": "HP_SendSmsText", "rid": 25, "paraJson": { "Para": msg, "Num": phone } });
        },
        Connect({ commit, state, dispatch }) {
            dispatch('pushTip', '--')
            let wsip = state.wsip;
            if (wsip == null || wsip == "") {
                dispatch('pushTip', '服务器地址不能为空.')
                return;
            }
            dispatch('pushTip', '开始连接.')

            let wsClient = new WebSocket(wsip);
            commit('SET_WSCLIENT', wsClient)

            const actionDispatch = dispatch;
            wsClient.onopen = function () {
                actionDispatch('judgeConnect')
                actionDispatch('oNreceid');
            }
        },
        oNreceid({ commit, state, dispatch }) {
            //这句非常重要，如果没有这句话，则无法正常通讯
            //  wsClient.send('Hello Server');
            //接收WS服务器返回的消息
            const actionDispatch = dispatch;
            state.wsClient.onmessage = function (e) {
                console.log('收到消息：' + e.data);
                actionDispatch('ExplainCommane', e.data);
            }
            state.wsClient.onclose = function (e) {
                actionDispatch('judgeConnect')
            }
        },
        judgeConnect({ commit, state, dispatch }) {
            let wsClient = state.wsClient;
            if (wsClient.readyState === WebSocket.CONNECTING) {
                dispatch('pushTip', "正在连接");
            } else if (wsClient.readyState === WebSocket.CLOSING) {
                dispatch('pushTip', "正在断开连接");
            } else if (wsClient.readyState === WebSocket.OPEN) {
                dispatch('pushTip', "已连接上：" + wsClient.url + " 可以通讯了");
                //连接上时，应先初始化设备。
                dispatch('onDevInit');
            } else if (wsClient.readyState === WebSocket.CLOSED) {
                dispatch('pushTip', "连接已关闭");
                dispatch('reInit');
            }
        },
        onDevInit({ commit, state, dispatch }) {
            dispatch('sentNCommand', { "cmd": "HP_Init", "rid": 1, "para": "0" });
        },
        sentNCommand({ commit, state, dispatch }, { cmd, rid, para }) {
            //发送一个普通的指令，只有Para或没有Para
            let strcommand = upUtils.commandNormal(cmd, rid, para);
            // dispatch('pushTip', strcommand); //打印指令
            state.wsClient.send(strcommand);
        },
        sentCommand({ commit, state, dispatch }, { cmd, rid, paraJson }) {
            //发送一个指令，完整的json格式
            let strcommand = upUtils.commandFull(cmd, rid, paraJson);
            // dispatch('pushTip', strcommand);  //打印指令
            state.wsClient.send(strcommand);
        },
        rsendCommand({ commit, state, dispatch }) {
            dispatch('pushTip', state.pre_command);
            state.wsClient.send(state.pre_command);
        },
        reInit({ commit, state, dispatch }) {
            // 重置连接
            commit('SET_PHONECODE', "");
            commit('SET_PHONECODESHOW', "");
            commit('SET_SPUSH', []);
            commit('SET_P_STATUS', 0);//摘挂机状态0:为挂机;1：为摘机;2:为HOLD;3：为耳机摘机
            commit('SET_R_STATUS', 0);//录音机状态： 0：停止录音 1:正在录音
            commit('SET_A_STATUS', 0);//答录的状态： 0：停止答录 1：准备答录 2:正在答录
            commit('SET_DV_STATUS', 0);//播号音开关: 0: 播号音关闭 1：播号音打开
            commit('SET_ICM_FLAG', 0);//ICM通道关：0；ICM通道开： 1
            commit('SET_PRE_COMMAND', '')
            commit('SET_RD_ICM', false)

            commit('SET_INP_PHONECODE', state.phoneCodeShow);
            dispatch('showDialDlg');

            //先清空这个链接，打电话的时候再联一次
            commit('SET_WSCLIENT', null)
        },
        onWSClose({ commit, state, dispatch }) {
            // 电话机离线后，关闭这个链接
            state.wsClient.close();
            dispatch('judgeConnect')
        },
        pushTip({ commit, state }, tip) {
            state.tip.push(tip);
            // commit('SET_TIP', tip);
        },
        pushPCS({ commit, state }) {
            commit('SET_SPUSH', []);
            commit('SET_PHONECODESHOW', "");
            commit('SET_INP_PHONECODE', state.phoneCodeShow);
        },
        clearTimeoutF({ commit, state, dispatch }) {
            if (state.incomTimeout != null) {
                clearTimeout(state.incomTimeout);
                commit('SET_INCOM_TIMEOUT', null);
            }
        },
        clearTimeoutA({ commit, state, dispatch }) {
            if (state.incomTimeout != null) {

            }
        },
        setP_status({ commit, state, dispatch }, status_temp) {
            commit('SET_PRE_P_STATUS', state.p_status);
            commit('SET_P_STATUS', status_temp);
        },
        showDialDlg({ commit, state, dispatch }) {
            //显示拨号的键盘，这个暂时没抄过来
        },
        showincomDlg({ commit, state, dispatch }) {
            //应该也是显示一个内容
        },
        showUIDialStatus({ commit, state, dispatch }, status_tmep) {
            //显示拨号状态，这个暂时没抄过来
        },
        stopRecorder({ commit, state, dispatch }) {
            //停止录音
            if (state.r_status == 0) {
                return;
            }
            console.log('停止录音')

            //停止录音指令
            console.log('发送停止录音指令')
            dispatch('sentCommand', { "cmd": "HP_StopRecordFile", "rid": 17, "paraJson": { "type": 1, "path": "", "user": "", "pawd": "" } });

            //上传到服务器
            var path = state.inp_recordaddr;
            if (path) {
                console.log('发送上传录音指令')
                dispatch('sentCommand', { "cmd": "HP_UpLoadFile", "rid": 30, "paraJson": { "remote": "hncs.cskaiyela.com/admin/v1/upload", "localfile": path } });
                console.log('发送上传录音指令end')
                commit('SET_INP_RECORDADDR', '') //置空录音地址
                message.info('录音文件上传云端完成！')
            }
        },
        autoRecord({ commit, state, dispatch }) {
            //自动录音,录音之前可能需要重新设置这个path
            var path = state.inp_recordaddr;
            if (path == null || path == "") {
                return;
            }
            //开始录音操作，Para录音文件名，完整的路径，这里只传本地路径，需要网络录音时，在停止录音里传网络路径
            dispatch('sentCommand', { "cmd": "HP_StartRecordFile", "rid": 16, "paraJson": { "type": 1, "Para": path } });
        },
        incomTimeoutF({ commit, state, dispatch }) {
            commit('SET_PHONECODE', "");
            commit('SET_PHONECODESHOW', "");
            dispatch('showDialDlg');
        },
        NotSendStopREvent({ commit, state, dispatch }) {
            // if (HasSendStopR == false) {

            //     HasSendStopR = true;
            //     //上传云录音
            //     upLoadRemoteR();

            //     rupload = document.getElementById("rupload");
            //     var value = rupload.value;
            //     if (value == "1") {

            //         var user = document.getElementById("inp_uploaduser").value;


            //         var pw = document.getElementById("inp_uploadpw").value;

            //         var netaddr = document.getElementById("inp_recorduploadaddr").value;
            //         if (netaddr == "" || netaddr == null) {
            //             window.alert("录音上传到网络，网络地址不能为空");
            //             return;
            //         }

            //         StopRTouchedBy17 = true;
            //         sendStopRecorder(user, pw, netaddr);

            //     }


            // } else {
            //     //上传云录音

            //     if (StopRTouchedBy17 != true) {
            //         upLoadRemoteR();
            //     }

            //     StopRTouchedBy17 = false;
            // }
        },
        answer_end({ commit, state, dispatch }) {
            dispatch('stopRecorder');
            dispatch('sentNCommand', { "cmd": "HP_HangUpCtrl", "rid": 4, "para": null });
        },
        addInp_phonecode({ commit, state, dispatch }, num) {
            commit('SET_PHONECODESHOW', state.spush.join(""))
            let spush = state.spush;
            spush.push(num);
            commit('SET_SPUSH', spush);
            commit('SET_PHONECODESHOW', state.spush.join(""))

            commit('SET_INP_PHONECODE', state.phoneCodeShow)
        },
        dloffHookDelay({ commit, state, dispatch }) {
            dispatch('sentNCommand', { "cmd": "HP_OffHookCtrl", "rid": 3, "para": null });
        },
        ExplainCommane({ commit, state, dispatch }, command) {
            //电话机驱动过来的消息
            //{"event":"HP_MsgEvent","type":"501","data":{"wParam":"0","lParam":"0"}}
            //还有一种是请求的返回
            //{"ret":0,"rid":1,"data":{"SerialNo":"设备串号","versoion":"1.00.0032","PhoneType":"USB"}}
            // {"ret":3,"rid":1,"err":"Para参数无效"}
            //事件通知，根据type类型不同，wParam和lParam含义不同
            try {
                var jsonString = JSON.parse(command);
            } catch (SyntaxError) {
                return;
            }
            var event = jsonString.event;
            var ret = jsonString.ret;
            if (event == null && ret == null) {
                return "err";
            } else {
                dispatch('pushTip', command);
            }
            if (event != null) { //事件通知
                var type = jsonString.type;
                var wParam = jsonString.data.wParam;
                var lParam = jsonString.data.lParam;
                //判断lParam的确类型
                console.log('事件：', jsonString)
                switch (type) {
                    /*case "520":
                        message.info(lParam);
                        break;*/
                    case "501":
                    case "511":
                        if (type == "501") {
                            commit('SET_ICM_FLAG', 0);
                        } else {
                            commit('SET_ICM_FLAG', 1);
                        }
                        commit('SET_CNNSTATE', '设备已连接');
                        break;
                    case "512":
                        commit('SET_ICM_FLAG', 1);
                        if (lParam == 1) {
                            commit('SET_CNNSTATE', '设备已连接(联机成功)');
                        } else {
                            commit('SET_CNNSTATE', '设备已连接(联机不成功)');
                        }
                        break;
                    case "502":
                        if (lParam == "0L") {
                            commit('SET_CNNSTATE', '设备已全部断开');
                        } else {
                            commit('SET_CNNSTATE', '已断开设备');
                        }
                        dispatch('onWSClose');
                        break;
                    case "515":
                        if (lParam == 1) {
                            message.info('对方已摘机')
                        } else {
                            message.info('对方已挂机')
                        }
                        break;
                    case "516":
                        if (lParam == 1) {
                            message.info('耳机插入')
                        } else {
                            message.info('耳机拔出')
                        }
                        break;
                    case "517":
                        dispatch('pushTip', "知信内容：" + lParam);
                        break;
                    case "518":
                        message.info(lParam)
                        break;

                    case "514":
                        //本机摘挂机状态
                        if (lParam == 1) {//本机摘机
                            if (state.ringCount > 0) {
                                if (state.a_status == 1) {
                                    commit('SET_RINGCOUNT', 0);
                                    //{"req":"HP_ playOGM","rid":29,"para":{"Para":"1"}}
                                    //留言录音，Para: 0关闭；1打开
                                    dispatch('sentNCommand', { "cmd": "HP_SetLeaveRecord", "rid": 10, "para": "1" });
                                    // showincomDlg();
                                    return;
                                }
                            }
                            dispatch('clearTimeoutF');
                            dispatch('setP_status', 1);
                            commit('SET_RINGCOUNT', 0);
                            commit('SET_A_STATUS', 0);

                            dispatch('clearTimeoutF');
                            dispatch('clearTimeoutA');
                            dispatch('showDialDlg');

                            commit('SET_INP_PHONECODE', state.phoneCodeShow)

                            if (state.r_status == 1) {
                                dispatch('stopRecorder');//停止上一次录音
                            }
                            //定时2秒后开始录音
                            if (state.autoRecordID != 0) {
                                clearTimeout(state.autoRecordID);
                            }
                            let autoRecordID = setTimeout(() => {
                                dispatch('autoRecord')
                            }, 2000);
                            commit('SET_AUTORECORDID', autoRecordID);

                            dispatch('showUIDialStatus', state.p_status);
                        } else {
                            dispatch('clearTimeoutF');
                            if (lParam == 0) {//本机挂机
                                if (state.r_status == 1) {
                                    dispatch('stopRecorder');//停止录音
                                }
                                commit('SET_RINGCOUNT', 0);
                                dispatch('setP_status', 0);
                                commit('SET_A_STATUS', 0);
                                dispatch('clearTimeoutA');
                                dispatch('pushPCS');

                                commit('SET_PHONECODE', "");
                                commit('SET_PHONECODESHOW', "");
                                if (state.r_status == 1) {

                                }
                            }
                            dispatch('showDialDlg');
                            commit('SET_INP_PHONECODE', state.phoneCodeShow)
                            dispatch('showUIDialStatus', state.p_status);
                        }
                        break;
                    case "503":
                        //电话摘机动作触发事件
                        //判断是否来铃
                        if (state.ringCount > 0) {
                            if (state.a_status == 1) {
                                commit('SET_RINGCOUNT', 0);
                                //{"req":"HP_ playOGM","rid":29,"para":{"Para":"1"}}
                                commit('SET_SETLEAVERECORDFLAG', 1);
                                //留言录音
                                dispatch('sentNCommand', { "cmd": "HP_SetLeaveRecord", "rid": 10, "para": "1" });
                                dispatch('showincomDlg');
                                return;
                            }
                        }

                        dispatch('clearTimeoutF');
                        dispatch('setP_status', 1);
                        commit('SET_RINGCOUNT', 0);
                        commit('SET_A_STATUS', 0);

                        dispatch('clearTimeoutF');
                        dispatch('clearTimeoutA');
                        dispatch('showDialDlg');

                        commit('SET_INP_PHONECODE', state.phoneCodeShow)
                        if (state.r_status == 1 && !state.holdTo503) {
                            commit('SET_HOLDTO503', false)
                            dispatch('stopRecorder');
                        }
                        //	setTimeout("playAnswerTip()",5000);
                        dispatch('showUIDialStatus', state.p_status);
                        break;
                    case "504":
                        //电话挂机动作触发事件
                        dispatch('clearTimeoutF');
                        if (lParam == "0") {

                            commit('SET_RINGCOUNT', 0);
                            dispatch('setP_status', 0);
                            commit('SET_A_STATUS', 0);
                            dispatch('clearTimeoutA');
                            commit('SET_ISDIALONLINE', false)

                            dispatch('pushPCS');

                            if (state.r_status == 1) {
                                dispatch('stopRecorder');
                            }
                            commit('SET_PHONECODE', "");
                            commit('SET_PHONECODESHOW', "");
                        } else if (lParam = "1") {
                            commit('SET_RINGCOUNT', 0);
                            dispatch('setP_status', 2);

                            commit('SET_PREDIALING', false)
                        }
                        dispatch('showDialDlg');

                        commit('SET_INP_PHONECODE', state.phoneCodeShow)
                        dispatch('showUIDialStatus', state.p_status);
                        commit('SET_HOLDTO503', false)

                        break;
                    case "505":
                        dispatch('showincomDlg');
                        commit('SET_PHONE_ICM', lParam)

                        commit('SET_PHONECODE', lParam);
                        commit('SET_PHONECODESHOW', lParam);
                        dispatch('clearTimeoutF');
                        break;
                    case "506": {
                        //来电响铃发此消息
                        if (state.icm_flag == 1) {
                            lParam = 0;
                            commit('SET_RINGCOUNT', 2);
                        } else {
                            if (state.a_status == 1) {
                                return;
                            }
                        }
                        if (lParam == 1) {
                            //表示本次来电铃声响
                        } else {
                            //表示本次来电铃声结束
                            commit('SET_RINGCOUNT', state.ringCount + 1);
                            if (state.ringCount >= 2) {
                                dispatch('showincomDlg');
                                dispatch('clearTimeoutF');

                                let incomTimeout = setTimeout(() => {
                                    dispatch('incomTimeoutF')
                                }, 5000);
                                commit('SET_INCOM_TIMEOUT', incomTimeout);

                                if (state.ringCount == 3) {
                                    // rd_dl = document.getElementById("rd_dl");
                                    // var value = rd_dl.value;
                                    let value = "0"//答录开关（不自动接听电话）
                                    if (value == "1") {
                                        dispatch('clearTimeoutF');
                                        commit('SET_A_STATUS', 1);
                                        commit('SET_AUDIOEND', 0);
                                        //{"req":"HP_OffHookCtrl","rid":3,"para":{}}
                                        //马上来铃就进行摘机操作会摘不起机。
                                        let dlyDlokTimeout = setTimeout(() => {
                                            dispatch('dloffHookDelay')
                                        }, 1000);
                                        commit('SET_DLYDLOKTIMEOUT', dlyDlokTimeout);
                                    }
                                }
                            } else {
                                if (state.icm_flag == 1) {
                                    //message.info("快乐幸福！")
                                    commit('SET_RINGCOUNT', 0);
                                    dispatch('setP_status', 0);
                                    commit('SET_A_STATUS', 0);
                                    dispatch('clearTimeoutA');
                                    //	btn_dial = document.getElementById("btn_dial");
                                    //	btn_dial.className = "btn btn-info btn-block";
                                    //	btn_dial.innerHTML = "摘机";
                                    dispatch('pushPCS');
                                    //if(r_status == 1 ){
                                    if (state.r_status == 1) {
                                        dispatch('stopRecorder');
                                    }

                                    commit('SET_PHONECODE', "");
                                    commit('SET_PHONECODESHOW', "");
                                    dispatch('showDialDlg');
                                }
                            }
                        }
                    }

                        break;
                    case "507":
                        if (state.p_status == 0) {
                            dispatch('setP_status', 1);
                            dispatch('showUIDialStatus', state.p_status);
                        }

                        if (state.has_dial == true) {
                            dispatch('pushPCS');
                            commit('SET_HAS_DIAL', false);
                        }
                        var temp = upUtils.deASCII(lParam);

                        if (state.isDialOnline == false) {
                            dispatch('addInp_phonecode', temp);
                        }
                        break;
                    case "508":

                        // document.getElementById("div_msg").innerHTML = recordText;
                        break;
                    case "509":
                        // var rd_mute = document.getElementById("rd_mute");
                        // if (lParam == 1) {
                        //     rd_mute.checked = true;
                        // } else {
                        //     rd_mute.checked = false;
                        // }
                        break;
                    case "510":
                        if (lParam == 0) {

                            //	btn_dial = document.getElementById("btn_dial");
                            //	btn_dial.className = "btn btn-danger btn-block";
                            //	btn_dial.innerHTML = "挂机";

                            // btn_dial = document.getElementById("btn_hold");
                            // btn_dial.className = "btn btn-info btn-block"; btn_dial.innerHTML = "保留";
                            commit('SET_HOLDTO503', false)
                            dispatch('setP_status', 1);
                        } else {

                            // h_status = 1;
                            //btn_dial = document.getElementById("btn_dial");
                            //btn_dial.className = "btn btn-primary btn-block";
                            //btn_dial.innerHTML = "保留";
                            // btn_hold = document.getElementById("btn_hold");
                            // btn_hold.className = "btn btn-danger btn-block";
                            // btn_hold.innerHTML = "解除保留";
                            commit('SET_HOLDTO503', true)
                            dispatch('setP_status', 3);
                        }
                        break;
                    /*提示服务器接收数据异常。此时客户端应再次发送上一条命令*/
                    case "519":
                        dispatch('rsendCommand');
                        break;
                }
            } else {
                var err = jsonString.err;
                var ret = jsonString.ret;
                var rid = jsonString.rid;
                var data = jsonString.data;
                var AnswerData = data.Ret;
                switch (rid) {
                    case 1:
                        var err = jsonString.err;
                        if (err != null) {
                            let hserial = "设备初始化错误:" + err;
                            commit('SET_SERIALNO', hserial)
                            return;
                        }
                        var no = data.SerialNo;
                        var p_type = data.PhoneType;
                        commit('SET_ICM_FLAG', 0)
                        if (p_type == "4G") {
                            commit('SET_ICM_FLAG', 1)
                            //  if(lParam == 1){
                            commit('SET_CNNSTATE', '设备已连接(联机成功)');
                            //}else{
                            //commit('SET_CNNSTATE', '设备已连接(联机不成功)');
                            //}
                        } else {
                            commit('SET_CNNSTATE', '设备已连接');
                        }
                        var hserial = "设备串号:" + no;
                        commit('SET_SERIALNO', hserial)
                        // onRaidoheClick();
                        break;
                    case 2:
                        if (AnswerData == "0") {

                        }
                        break;
                    case 3:
                        if (AnswerData == "0") {
                            if (state.ringCount > 0) {
                                if (state.a_status == 1) {
                                    return;
                                }
                            }
                            commit('SET_INP_PHONECODE', state.phoneCodeShow)
                            dispatch('showDialDlg');

                            dispatch('clearTimeoutA');
                            dispatch('setP_status', 1);
                            dispatch('showUIDialStatus', state.p_status);
                        }
                        break;
                    case 4:
                    case 26:
                        //来电拒接的回调
                        if (AnswerData == "0") {
                            dispatch('setP_status', 0);
                            commit('SET_A_STATUS', 0);
                            if (state.r_status == 1) {
                                dispatch('stopRecorder');
                            }

                            dispatch('pushPCS');
                            dispatch('showDialDlg');
                            commit('SET_PHONECODE', "");
                            commit('SET_PHONECODESHOW', "");

                            commit('SET_INP_PHONECODE', state.phoneCodeShow)
                            dispatch('clearTimeoutA');
                            dispatch('setP_status', 0);
                            dispatch('showUIDialStatus', state.p_status);
                        }
                        break;
                    case 25:
                        //发送短信回来
                        message.success("短信发送" + (AnswerData == 0 ? "成功" : "失败"));
                    case 5:
                        if (AnswerData == "0") {
                            commit('SET_A_STATUS', 0);
                            if (state.has_dial == true) {
                                dispatch('pushPCS');
                                commit('SET_HAS_DIAL', false);
                            }
                            dispatch('clearTimeoutA');
                        }
                        break;
                    case 6:
                        // var rd_ring = document.getElementById("rd_ring");
                        // if (AnswerData == "0") {
                        //     var sopen = rd_ring.value;
                        //     if (sopen == "1") {
                        //         rd_ring.checked = false;
                        //         rd_ring.value = "0";
                        //     } else {
                        //         rd_ring.checked = true;
                        //         rd_ring.value = "1";
                        //     }
                        // }
                        break;
                    case 7:
                        //spush.pop();
                        break;
                    case 8:
                        switch (AnswerData) {
                            case "0":
                                commit('SET_PHONECODE', "");
                                commit('SET_PHONECODESHOW', "");
                                dispatch('setP_status', 0);

                                break;
                            case "1":
                                dispatch('setP_status', 1);

                                break;
                            case "2"://耳机摘机
                                dispatch('setP_status', 3);
                                break;
                            case "3":
                                dispatch('setP_status', 1);
                                break;
                        }
                        dispatch('showUIDialStatus', state.p_status);
                        break;
                    case 9:
                        // var rd_voice = document.getElementById("rd_voice");
                        // if (AnswerData == "0") {
                        //     var sopen = rd_voice.value;
                        //     if (sopen == "1") {
                        //         rd_voice.checked = false;
                        //         rd_voice.value = "0";
                        //     } else {
                        //         rd_voice.checked = true;
                        //         rd_voice.value = "1";

                        //     }
                        // }
                        break;
                    case 11:
                        if (AnswerData == "0") {
                            commit('SET_PHONECODE', "");
                            commit('SET_PHONECODESHOW', "");
                            commit('SET_INP_PHONECODE', '')
                        }
                        break;
                    case 12:
                        // var rd_dvoice = document.getElementById("rd_dvoice");
                        // if (AnswerData == "0") {
                        //     var sopen = rd_dvoice.value;
                        //     if (sopen == "1") {
                        //         rd_dvoice.checked = false;
                        //         rd_dvoice.value = "0";
                        //     } else {
                        //         rd_dvoice.checked = true;
                        //         rd_dvoice.value = "1";
                        //     }
                        // } else {
                        //     var sopen = rd_dvoice.value;
                        //     if (sopen == "0") {
                        //         rd_dvoice.checked = false;
                        //     } else {
                        //         rd_dvoice.checked = true;
                        //     }
                        // }
                        break;
                    case 13:
                        // var rd_answer = document.getElementById("rd_answer");
                        // if (AnswerData == "0") {
                        //     var sopen = rd_answer.value;
                        //     if (sopen == "1") {
                        //         rd_answer.checked = false;
                        //         rd_answer.value = "0";
                        //     } else {
                        //         rd_answer.checked = true;
                        //         rd_answer.value = "1";
                        //     }
                        // } else {
                        //     var sopen = rd_answer.value;
                        //     if (sopen == "0") {
                        //         rd_answer.checked = false;
                        //     } else {
                        //         rd_answer.checked = true;
                        //     }
                        // }
                        break;
                    case 14:
                        if (AnswerData == "0") {
                            message.info("Flash时间设置成功!");
                        }
                        break;
                    case 15:
                        if (AnswerData == "0") {
                            message.info("出局码设置成功!");
                        }
                        break;
                    case 16:
                        if (AnswerData == "0") {
                            commit('SET_R_STATUS', 1);
                            if (state.a_status == 2) {
                                commit('SET_A_STATUS', 3);
                                setTimeout(() => {
                                    dispatch('answer_end')
                                }, 30000);
                            } else {
                                commit('SET_R_STATUS', 1);
                                // btn_record = document.getElementById("record");
                                // btn_record.className = "btn btn-success btn-block";
                            }
                        } else {
                            message.info("录音不成功！");
                        }
                        break;
                    case 17:
                        var temp_a = state.a_status;
                        var temp_r = state.r_status;
                        commit('SET_R_STATUS', 0);
                        commit('SET_A_STATUS', 0);
                        // btn_record = document.getElementById("record");
                        // btn_record.className = "btn btn-default";
                        dispatch('NotSendStopREvent');

                        if (AnswerData == "0") {

                            //var temp_a = a_status;
                            //var temp_r = r_status;
                            //r_status = 0;
                            //a_status = 0;
                            //btn_record = document.getElementById("record");
                            //btn_record.className = "btn btn-default";
                            //dispatch('NotSendStopREvent');

                            //if(temp_r == 1 && temp_a > 0){
                            //sentNCommand("HP_HangUpCtrl",4,null);
                            //}
                        } else if (AnswerData == "1") {
                            message.info("停止录音失败！");
                        } else if (AnswerData == "2") {
                            message.info("访问径失败！");
                        } else if (AnswerData == "3") {
                            message.info("复制文件到网络路径失败！");
                        }
                        break;
                    case 30:
                        if (AnswerData == "0") {

                        } else if (AnswerData == "1") {
                            message.info("录音文件上传云端失败！");
                        }
                        break;
                    case 18:
                        if (AnswerData == "0") {
                            commit('SET_PHONECODE', "");
                            commit('SET_PHONECODESHOW', "");
                            commit('SET_INP_PHONECODE', '')
                        }
                        break;
                    case 19:
                        if (state.p_status == 1 || state.p_status == 3) {

                            dispatch('setP_status', 2);
                            dispatch('showUIDialStatus', state.p_status);
                            commit('SET_HOLDTO503', true)
                        } else {
                            dispatch('setP_status', state.pre_p_status);
                            dispatch('showUIDialStatus', state.p_status);
                        }
                        break;
                    case 20:
                        // var rd_mute = document.getElementById("rd_mute");
                        // if (AnswerData == "0") {

                        //     var sopen = rd_mute.value;

                        //     if (sopen == "1") {

                        //         rd_mute.checked = false;
                        //         rd_mute.value = "0";

                        //     } else {

                        //         rd_mute.checked = true;
                        //         rd_mute.value = "1";

                        //     }
                        // }
                        break;
                    case 21:
                        // var rd_pchs = document.getElementById("rd_voice");
                        // if (AnswerData == "0") {

                        //     var sopen = rd_pchs.value;

                        //     if (sopen == "1") {

                        //         rd_pchs.checked = false;
                        //         rd_pchs.value = "0";

                        //     } else {

                        //         rd_pchs.checked = true;
                        //         rd_pchs.value = "1";

                        //     }
                        // }
                        break;
                    case 22:
                        // var rd_mobilehs = document.getElementById("rd_mobilehs");
                        // if (AnswerData == "0") {

                        //     var sopen = rd_mobilehs.value;

                        //     if (sopen == "1") {

                        //         rd_mobilehs.checked = false;
                        //         rd_mobilehs.value = "0";

                        //     } else {

                        //         rd_mobilehs.checked = true;
                        //         rd_mobilehs.value = "1";

                        //     }
                        // } else {
                        //     var sopen = rd_mobilehs.value;

                        //     if (sopen == "1") {

                        //         rd_mobilehs.checked = true;


                        //     } else {

                        //         rd_mobilehs.checked = false;


                        //     }

                        // }
                        break;
                    case 23:
                        var rd_icm = state.rd_icm;
                        if (AnswerData == "0") {
                            var sopen = state.rd_icm;
                            if (sopen == "1") {
                                commit('SET_RD_ICM', false)
                                //icm_flag = 0;
                            } else {
                                commit('SET_RD_ICM', true)
                                //icm_flag = 1;
                            }
                        } else {
                            var sopen = state.rd_icm;
                            if (sopen == "1") {
                                rd_icm.checked = true;
                            } else {
                                rd_icm.checked = false;
                            }
                        }
                        break;
                    case 24:
                        break;
                    case 27:
                        commit('SET_RD_ICM', false)
                        if (AnswerData == "0") {
                            message.info("信息删除成功");
                        } else {
                            message.info("信息删除不成功");
                        }
                        break;
                    case 28:
                        if (state.p_status != 3) {
                            commit('SET_P_STATUS', 3);
                            // rd_he = document.getElementById("rd_he");
                            // rd_he.value = "1";
                            // rd_he.checked = true;
                        }
                        break;
                    case 10:
                        if (state.SetLeaveRecordFlag == 1) {
                            if (state.a_status == 1) {
                                commit('SET_A_STATUS', 2)
                                // mAudio = document.getElementById("audio1");
                                // mAudio.addEventListener('ended', function () {
                                //     if (state.audioend == 0) {
                                //         commit('SET_AUDIOEND', 1);
                                //         var path = state.inp_recordaddr;
                                //         if (path == null || path == "") {
                                //             return;
                                //         }
                                //         dispatch('sentCommand', "HP_StartRecordFile", 16, { "type": 2, "Para": path });
                                //     }
                                // }, false);

                                // playAnswerTip();
                            }
                        }
                        break;
                    case 35: {
                        if (AnswerData == "0") {
                            commit('SET_CNNSTATE', '设备已连接');
                            message.info("话机连接正常!");
                        } else if (AnswerData == "1") {
                            commit('SET_CNNSTATE', '设备未连接(此提示只针对4G电话)');
                            message.info("话机未连接!");
                        }
                    }
                        break;
                    case 44: {
                        if (AnswerData == "NULL") {
                            message.info("序列号为空！");
                        }
                        commit('SET_INP_SERIAL', AnswerData);
                        message.info("本机的序列号为:" + AnswerData);
                    }
                        break;
                }
            }
            return null;
        }
    },
    namespaced: true//启用名称空间
}
// 相关辅助方法
const upUtils = {
    /**
     * 构造一个普通命令，参数只有一个Para或者没有
     * @param cmd
     * @param rid
     * @param Para  null或者字符串
     * @returns
     */
    commandNormal: function (cmd, rid: number, Para: string | null) {
        var jsonp = {};
        if (Para !== null) {
            jsonp = { "Para": Para }
        }
        var jsonCommand = {
            "req": cmd,
            "rid": rid,
            "para": jsonp
        };
        var jsonStr = JSON.stringify(jsonCommand);
        return jsonStr;
    },
    commandFull: function (cmd, rid: number, paraJson: JSON) {
        var jsonCommand = {
            "req": cmd,
            "rid": rid,
            "para": paraJson
        };
        var jsonStr = JSON.stringify(jsonCommand);
        return jsonStr;
    },
    deASCII: function (num) {
        switch (num) {
            case 48:
                return "0";

            case 49:
                return "1";
            case 50:
                return "2";
            case 51:
                return "3";
            case 52:
                return "4";
            case 53:
                return "5";
            case 54:
                return "6";
            case 55:
                return "7";
            case 56:
                return "8";
            case 57:
                return "9";
            case 35:
                return "#";
            case 42:
                return "*";
        }
        return null
    }


}
export default usbphone
